import { FC } from 'react';
import cn from 'classnames';
import styles from './LandscapeProjectsAddProjectsDocumentsTemplate.module.css';
import { Container } from 'react-bootstrap';
import {
  LandscapeDocumentsOrganism,
  UploadDocumentOrganism,
} from '../../organisms';
import { LandscapeDocumentResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-document-response.dto';
import { FileMeta } from '../../../store/mediaAPI/document/dto/request/document-save-request';
import LandscapeEditProjectsAddProjectTemplate from '../../../templates/LandscapeEditProjectsAddProjectTemplate';

export interface LandscapeProjectsAddProjectsDocumentsTemplateProps {
  data: LandscapeDocumentResponseDto[];
  handleEditAction: (id: string) => void;
  handleDownload: (id: string) => void;
  handleDelete: (id: string) => void;
  handleFileMetaOnChange: (fileMeta: FileMeta) => void;
  handleFileOnChange: (file: string) => void;
  handleFileNameOnChange: (name: string) => void;
  callbackFn: () => void;
}

const LandscapeProjectsAddProjectsDocumentsTemplate: FC<
  LandscapeProjectsAddProjectsDocumentsTemplateProps
> = ({
  data,
  handleEditAction,
  handleDownload,
  handleDelete,
  handleFileMetaOnChange,
  handleFileOnChange,
  handleFileNameOnChange,
  callbackFn,
}) => {
  return (
    <Container>
      <LandscapeEditProjectsAddProjectTemplate>
        <div className={cn(styles.landscapeDocumentsWrapper)}>
          <LandscapeDocumentsOrganism
            data={data}
            handleEditAction={handleEditAction}
            handleDelete={handleDelete}
            handleDownload={handleDownload}
          />
        </div>
        <UploadDocumentOrganism
          setFile={(file) => handleFileOnChange(file)}
          setFileMeta={(fileMeta) => handleFileMetaOnChange(fileMeta)}
          setName={(name) => handleFileNameOnChange(name)}
          callbackFn={callbackFn}
        />
      </LandscapeEditProjectsAddProjectTemplate>
    </Container>
  );
};

export default LandscapeProjectsAddProjectsDocumentsTemplate;
